import React from 'react';
import BadgesPage from '../components/Awards/BadgesPage';

/* /student/badges: my badges & medals + the Wall of fame */
const StudentBadges = () => <BadgesPage mode="student" />;

export default StudentBadges;
